<template>
  <div id="media-tendency-page">
    <page-header-component
      icon="bi bi-arrow-left-right"
      title="Media Tendency"
      @filterChange="filterChange"
    />
    <div v-if="isLoading" class="card mb-4 shade">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8 col-sm-12">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Grafik Tendency Bar</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <loader-component />
          </div>
        </div>
      </div>
    </div>
    <tendency-bar-component
      v-else
      :data="barOption"
      :barchart_id="'media-tendency-barchart'"
    />
    <div v-if="isLineLoading" class="card m-b-10 shade">
      <div class="card-body">
        <div class="row">
          <div class="col-md-8 col-sm-12">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Grafik Tren Tendency Harian</h4>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <loader-component />
          </div>
        </div>
      </div>
    </div>
    <tren-tendency-component
      v-else
      :data="barOptionLine"
      :linechart_id="'media-tendency-line'"
    />
  </div>
</template>
<script>
import page_header from "@/views/components/page_header.vue";
import tendency_bar from "@/views/components/analytics/media-tendency/tendency_bar.vue";
import tren_tendency from "@/views/components/analytics/media-tendency/tren_tendency.vue";
import loader_component from "@/views/components/loader.vue";

export default {
  name: "MediaTendency",
  title: "Analytics Media Tendency | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "tendency-bar-component": tendency_bar,
    "tren-tendency-component": tren_tendency,
    "loader-component": loader_component,
  },
  data() {
    return {
      barOption: {},
      barOptionLine: {},
      id_project: this.$store.getters.user.id_project,
      isLoading: true,
      isLineLoading: true,
    };
  },
  mounted: function () {
    this.getDataTendency();
    this.getDataTrenTendency();
  },
  methods: {
    filterChange: function () {
      this.isLoading = true;
      this.isLineLoading = true;
      this.getDataTendency();
      this.getDataTrenTendency();
    },
    getDataTendency: function () {
      let api = process.env.VUE_APP_API_URL + "tendency/bar/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.barOption = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDataTrenTendency: function () {
      let api =
        process.env.VUE_APP_API_URL + "tendency/line/" + this.id_project;
      let query = {
        from: this.$route.query.from,
        to: this.$route.query.to,
      };
      this.$http
        .get(api, { params: query })
        .then((response) => {
          if (response.status == 200) {
            this.barOptionLine = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLineLoading = false;
        });
    },
  },
};
</script>
